import React, {useEffect, useState} from 'react';
import {consignorService} from '../../../services';
import {Modal, Input, notification, Table} from 'antd';
import Spinner from "../../spinner";
import i18n from '../../../i18n';
import {getWithTranslate} from "../../../helpers/doc_type.helper";

export default function ModalShipperCompanyFullInfo({shipperCompanyId, isShow, setIsShow}) {
  const shipperCompanyDataAliases = {
    OrgForm: i18n.t('constants.shipperCompanyDataAliases.orgForm'),
    DateRegistration: i18n.t('constants.shipperCompanyDataAliases.dateRegistration'),
    Name: i18n.t('constants.shipperCompanyDataAliases.name'),
    WorkWithNds: i18n.t('constants.shipperCompanyDataAliases.workWithNds'),
    LegalReason: i18n.t('constants.shipperCompanyDataAliases.legalReason'),
    FirstName: i18n.t('constants.shipperCompanyDataAliases.firstName'),
    SecondName: i18n.t('constants.shipperCompanyDataAliases.secondName'),
    Patronymic: i18n.t('constants.shipperCompanyDataAliases.patronymic'),
    Inn: i18n.t('constants.shipperCompanyDataAliases.inn'),
    Kpp: i18n.t('constants.shipperCompanyDataAliases.kpp'),
    Ogrn: i18n.t('constants.shipperCompanyDataAliases.ogrn'),
    Ogrnip: i18n.t('constants.shipperCompanyDataAliases.ogrnip'),
    Okpo: i18n.t('constants.shipperCompanyDataAliases.okpo'),
    Rs: i18n.t('constants.shipperCompanyDataAliases.rs'),
    Bic: i18n.t('constants.shipperCompanyDataAliases.bic'),
    BankName: i18n.t('constants.shipperCompanyDataAliases.bankName'),
    Country: i18n.t('constants.shipperCompanyDataAliases.country'),
    RegAddress: i18n.t('constants.shipperCompanyDataAliases.regAddress'),
    MailingAddress: i18n.t('constants.shipperCompanyDataAliases.mailingAddress'),
    LegalAddressPostalCode: i18n.t('constants.shipperCompanyDataAliases.legalAddressPostalCode'),
    AtiCode: i18n.t('constants.shipperCompanyDataAliases.atiCode'),
    PositionStr: i18n.t('constants.shipperCompanyDataAliases.positionStr'),
  };

  const [loading, setLoading] = useState(true);

  const [legalEntityInfo, setLegalEntityInfo] = useState([]);

  const [columns, setColumns] = useState([
    {
      title: '',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '',
      key: 'data',
      render: (record) => {
        function isUrl(string) {
          let regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
          return regexp.test(string);
        }

        if (isUrl(record.data)) {
          return (
            <React.Fragment>
              <a href={record.data} target="_blank" rel="noopener noreferrer"
                 className="active">{i18n.t('main.buttons.open')}</a>
            </React.Fragment>
          );
        } else {
          if (record.data === 0 || record.data === 1) {
            return record.data ? i18n.t('main.yes') : i18n.t('main.no');
          }
          return record.data
        }
      }
    },
  ]);

  useEffect(() => {
    if (isShow) {
      consignorService.geShipperCompanyInfo(shipperCompanyId)
        .then((response) => {
          setLoading(false);

          let data = [];
          Object.keys(response).forEach((element) => {
            if (response[element] !== null && response[element] !== '') {
              if (typeof shipperCompanyDataAliases[element] !== 'undefined') {
                data.push(
                  {
                    name: shipperCompanyDataAliases[element],
                    data: response[element]
                  }
                );
              }
            }
          });

          if (response.Director) {
            Object.keys(response.Director).forEach((element) => {
              data.push(
                {
                  name: shipperCompanyDataAliases[element],
                  data: response.Director[element]
                }
              );
            });
          }

          const legalEntityDataAliases = getWithTranslate('legalEntityDataAliases');

          Object.keys(response.Docs).forEach((element) => {
            if (response.Docs[element] !== null) {
              let document = response.Docs[element];
              const documentName = legalEntityDataAliases[response.Docs[element].Name] ? legalEntityDataAliases[response.Docs[element].Name]: document.Name;
              data.push(
                {
                  name: documentName,
                  data: document.Url
                }
              );
            }
          });

          setLegalEntityInfo(data);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getOrders'),
            description: err
          });
          setLoading(false);
          setIsShow(false);
        });
    }

  }, [isShow]);

  return (
    <Modal
      title={i18n.t('modals.modalShipperCompanyFullInfo.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={null}
    >
      <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
        <Table
          columns={columns}
          dataSource={legalEntityInfo}
          rowKey="name"
          pagination={false}
          size="small"
        />
      </Spinner>
    </Modal>
  );

}
